import { useEffect, useMemo, useState } from "react";

import {
    getRoles,
    deleteRole,
} from "../services/roleApi";

import RoleHeader from "../components/roles/RoleHeader";
import RoleStats from "../components/roles/RoleStats";
import RoleFilters from "../components/roles/RoleFilters";
import RoleTable from "../components/roles/RoleTable";

import "../css/Roles.css";

function Roles() {

    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(true);

    const [filters, setFilters] = useState({
        search: "",
        status: "",
    });

    const loadRoles = async () => {

        try {

            setLoading(true);

            const res = await getRoles();

            setRoles(res.data.roles || []);

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        loadRoles();

    }, []);

    const handleFilterChange = (key, value) => {

        setFilters((prev) => ({
            ...prev,
            [key]: value,
        }));

    };

    const filteredRoles = useMemo(() => {

        let data = [...roles];

        if (filters.search) {

            const search = filters.search.toLowerCase();

            data = data.filter((role) =>
                role.roleName.toLowerCase().includes(search)
            );

        }

        if (filters.status) {

            data = data.filter(
                (role) => role.status === filters.status
            );

        }

        return data;

    }, [roles, filters]);

    return (

        <div className="roles-page">

            <RoleHeader reload={loadRoles} />

            <RoleStats roles={roles} />

            <RoleFilters
                filters={filters}
                onChange={handleFilterChange}
            />

            <RoleTable
                roles={filteredRoles}
                loading={loading}
                onDelete={deleteRole}
                reload={loadRoles}
            />

        </div>

    );

}

export default Roles;